import React, { useState } from "react"
import * as S from "./form-popup.styles"
import { Grid, Typography } from "@mui/material"
import { FormProvider, useForm } from "react-hook-form"
import CustomInput from "../../components/custom-input/custom-input.component"
import CustomButton from "../../components/custom-button/custom-button.component"
import CustomCheckboxGroup from "../custom-checkbox-group/custom-checkbox-group.component"
import Close from "../../assets/icons/close-circle.svg"
import { emailRegex, isBrowser } from "../../utils/utils"
import CustomSelect from "../custom-select/custom-select.component"
import Copia from "../../assets/icons/copia-header-logo.svg"
import CustomLink from "../custom-link/custom-link.component"
import { contactFormApi } from "../../apis/apis"
import { toast } from "react-toastify"

const FormPopup = ({ open, handleClose }) => {
  const formId = "457"
  const methods = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  })
  const [isLoading, setIsLoading] = useState(false)
  const { handleSubmit, reset } = methods

  const onSubmit = async data => {
    setIsLoading(true)
    await contactFormApi
      .post(`/${formId}/feedback`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        setIsLoading(false)
        if (response.data) {
          if (response.data.status === "mail_sent") {
            handleClose()
            toast.success(response.data.message)
            if (isBrowser && window.gtag) {
              window.gtag("event", `form_submit`)
            }
            reset({
              First_Name: "",
              Last_Name: "",
              Designation: "",
              Email: "",
              Phone: "",
              Number_of_Participating_Locations: "",
              Industry: "-None-",
              Services_Interested_In_select_multiple: [],
              Other_Information: "",
            })
          } else {
            toast.error(response.data.message)
          }
        }
      })
      .catch(err => err)
  }

  return (
    <S.CustomDialog open={open} onClose={handleClose}>
      <S.CloseButton onClick={handleClose}>
        <Close />
      </S.CloseButton>
      <S.Wrapper>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <S.Logo>
              <Copia />
            </S.Logo>
            <S.Title>
              Join thousands of businesses across the United States already
              partnering with Copia
            </S.Title>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <CustomInput
                  name="First_Name"
                  placeholder="First Name"
                  validations={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInput
                  name="Last_Name"
                  placeholder="Last Name"
                  validations={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInput name="Designation" placeholder="Title" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInput
                  name="Company"
                  placeholder="Company"
                  validations={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInput name="Phone" placeholder="Contact Number" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomInput
                  name="Email"
                  placeholder="Email"
                  validations={{ required: true, pattern: emailRegex }}
                />
              </Grid>
            </Grid>
            <S.BottomWrapper>
              <Grid container columnSpacing={1} rowSpacing={3}>
                <Grid item xs={12} sm={6}>
                  <CustomInput
                    name="Number_of_Participating_Locations"
                    placeholder="# of Participating locations"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomSelect
                    size="small"
                    items={[
                      "-None-",
                      "Catering",
                      "Corporate Dining",
                      "Restaurant",
                      "Venue",
                      "Specific Events",
                      "Hotel",
                      "Stadium",
                      "Grocery",
                      "Event Planning",
                      "Waste Management",
                      "Healthcare",
                      "Philantropic",
                      "Education",
                      "Food Management Company",
                    ]}
                    placeholder="-None-"
                    defaultValue="-None-"
                    name="Industry"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomCheckboxGroup
                    items={[
                      {
                        value: "Waste Tracking/Prevention",
                        label: "Waste Tracking/Prevention",
                      },
                      {
                        value: "Food Donation Services",
                        label: "Food Donation Services",
                      },
                      { value: "Other", label: "Other" },
                    ]}
                    title="Services interested in: "
                    name="Services_Interested_In_select_multiple"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    multiline
                    rows={3}
                    name="Other_Information"
                    placeholder="Other information"
                  />
                </Grid>
                <Grid item xs={12}>
                  <S.ButtonWrapper>
                    <CustomButton
                      className="linearGradient"
                      fullWidth
                      type="submit"
                      loading={isLoading}
                    >
                      Let’s do this!
                    </CustomButton>
                  </S.ButtonWrapper>
                </Grid>
                <Grid item xs={12}>
                  <S.Note>
                    <Typography>Not a business?</Typography>{" "}
                    <CustomLink url={"/nonprofits/"}>
                      Sign up to receive food
                    </CustomLink>
                  </S.Note>
                </Grid>
              </Grid>
            </S.BottomWrapper>
          </form>
        </FormProvider>
      </S.Wrapper>
    </S.CustomDialog>
  )
}

export default FormPopup
